import { defineMessages } from 'react-intl';

export default defineMessages({
    wizard: {
        id: 'quoteandbind.cp.wizard.step.Quote',
        defaultMessage: 'Quote',
    },
});
